import registerProviderMain from "./registerProviderMain";
import verifiedProvider from "./verifiedProvider";
import ViewProvider from "./viewProvider";
const registerProvider={
     registerProviderMain,
     verifiedProvider,
     ViewProvider
}
export default registerProvider